import { LoadingUtil } from 'lib-vue-v2/util';
import { useMessageBox } from "lib-vue-v2/composables";
import { Resource as CommonResource } from "@/models/Message/Resource/CommonResource";
import { AndroidAgentSetting } from '@/views/Mobile/Android/GoogleAccountSetting/model/AndroidAgentSetting';
import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema';
import { BaseResponseDto } from "./BaseResponseDto";

// メッセージ用
const { showMessageBox } = useMessageBox();

// c#からくるレスポンス
interface AndroidAgentPolicySettingDto {
    agentId: number;
    agentSetting: string;
}
interface GetAndroidAgentSettingResponseDto extends BaseResponseDto {
    agentSettings: AndroidAgentPolicySettingDto[];
}


export default function useGetAndroidAgentSettingPackage() {
    // 実行
    const executeAsync = async (): Promise<[boolean, AndroidAgentSetting[]]> => {
        try {
            LoadingUtil.Start();

            const jsonResponse = await window.chrome?.webview?.hostObjects.class.GetAndroidDeviceSettingInfo();
            if (jsonResponse === undefined) {
                showErrorMessage();
                return [false, []];
            }
            const response = JSON.parse(jsonResponse) as GetAndroidAgentSettingResponseDto;

            // failed
            if (!response.isSuccess) {
                showErrorMessage();
                return [false, []];
            }

            // success
            const settings: AndroidAgentSetting[] = response.agentSettings.map(e => {
                return {
                    agentNo: e.agentId,
                    setting: Object.assign(new schema.AMAPI_Policy, JSON.parse(e.agentSetting as string))
                };
            });
            return [true, settings];
        }
        catch {
            // 想定外error
            showErrorMessage();
            return [false, []];
        }
        finally {
            LoadingUtil.Stop();
        }
    }

    // エラーメッセージ表示
    const showErrorMessage = (): void => {
        // データの取得に失敗しました。
        showMessageBox(CommonResource.CommonResource.getInstance().getMsgInfo(CommonResource.MsgID.GetFailedErrorForMessage));
        return;
    }

    // 外部公開
    return {
        executeAsync
    }
}